import { Generation } from "@app/store/types";
import { CURRENT_YEAR, START_YEAR_PRODUCTION } from "@shared/config/Date";
import { numberToRoman } from "../numberToRoman";

export const generateGenerationLabel = (generation?: Generation | null): string => {
    if (!generation || !generation.id) return "";

    const generationNum = generation.generation ? numberToRoman(generation.generation) : "";
    const fullName = generation.name ? `${generationNum} ${generation.name}` : generationNum;

    const validStartedAt =
        generation.startedAt && generation.startedAt >= START_YEAR_PRODUCTION
            ? generation.startedAt
            : undefined;
    const validEndedAt =
        generation.endedAt && generation.endedAt >= START_YEAR_PRODUCTION
            ? generation.endedAt
            : CURRENT_YEAR;

    const period = validStartedAt ? `${validStartedAt} - ${validEndedAt}` : "";
    const restyle = generation.restyleNumber ? `${generation.restyleNumber} Рестайлинг` : "";

    const fullLabel = [period, fullName, restyle].filter(Boolean).join(" ");
    return fullLabel;
};